import { PlayerData } from '@/types/players.types';

interface MedalsRowProps {
  noMedalsWasAwarded: boolean;
  gold: string;
  silver: string;
  bronze: string;
  player?: PlayerData;
}

const MedalsRow = ({ noMedalsWasAwarded, gold, silver, bronze, player }: MedalsRowProps) => {
  const isPlayerNameInMedal = (medalName: string): boolean => {
    if (!player) return false;
    const fullName = `${player.firstName} ${player.lastNameAndSuffix}`.trim();
    const winners = medalName.split(/[/&]/).map((name) => name.trim());
    return winners.some((winner) => winner === fullName);
  };

  return (
    <>
      {!noMedalsWasAwarded ? (
        <div className='flex min-h-[48px] flex-wrap items-center justify-center rounded-b-lg border-x border-b border-gray-200 p-3 text-xs sm:p-2 sm:text-base'>
          <div className='flex items-center'>
            <p className='mr-1'>Gold:</p>
            <p className={`font-semibold ${isPlayerNameInMedal(gold) ? 'text-green-600' : ''}`}>
              {gold}
            </p>
            <div className='mx-4 h-[14px] w-0.5 bg-gray-300' />
          </div>
          <div className='flex items-center'>
            <p className='mr-1'>Silver:</p>
            <p className={`font-semibold ${isPlayerNameInMedal(silver) ? 'text-green-600' : ''}`}>
              {silver}
            </p>
            <div className='mx-4 h-[14px] w-0.5 bg-gray-300' />
          </div>
          <div className='flex items-center'>
            <p className='mr-1'>Bronze: </p>
            <p className={`font-semibold ${isPlayerNameInMedal(bronze) ? 'text-green-600' : ''}`}>
              {bronze}
            </p>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default MedalsRow;
